import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './style.module.css';
import NaviButton from '../../compoenets/NaviButton';

const urlMatchMenu={
    'dashboard':1,
    'task-evaluation':2,
    'device-timeline':3,
    'playground':4,
}

export default function Sidebar({className}){
    const location=useLocation();
    const [onMenu,setOnMenu]=useState(null);

    useEffect(()=>{
        const pathSeg=location.pathname.split('/');
        if(pathSeg[1]){
            setOnMenu(urlMatchMenu[pathSeg[1]])
        }
    },[location.pathname])
  
    const navigate=useNavigate();
    const viewNavigate=(newRoute)=>{
        if (!document.startViewTransition) {
          return navigate(newRoute);
        } else {
          return document.startViewTransition(() => {
            navigate(newRoute);
          });
        }
    }

    const handleClickMenu=(e)=>{
        e.stopPropagation();
        if(e==onMenu)return;
        const btn=e.currentTarget.querySelector('button');
        if(btn)btn.click();
    }

    return(
        <nav className={`${className} ${styles['wrap']}`}>
            <header className={styles['header']}>
              <span onClick={()=>{viewNavigate("/")}}>UT Dashboard</span>
            </header>
            <div className={styles['body']}>
                <ul className={styles['task-wrap']}>
                    <li 
                    key={1}
                    className={`${onMenu===1&&styles['selected-menu']} ${styles['menu-item']}`}
                    onClick={handleClickMenu}>
                        <NaviButton to="/dashboard">Dashboard</NaviButton>
                        {/* <div className={styles['menu-tip']}>Dashboard</div> */}
                    </li>
                    <li 
                    key={2}
                    className={`${onMenu===2&&styles['selected-menu']} ${styles['menu-item']}`}
                    onClick={handleClickMenu}>
                        <NaviButton to="/task-evaluation">Task Evaluation</NaviButton>
                        {/* <div className={styles['menu-tip']}>Playground</div> */}
                    </li>
                    <li 
                    key={3}
                    className={`${onMenu===3&&styles['selected-menu']} ${styles['menu-item']}`}
                    onClick={handleClickMenu}>
                        <NaviButton to="/device-timeline">Device Timeline</NaviButton>
                        {/* <div className={styles['menu-tip']}>Playground</div> */}
                    </li>
                    <li 
                    key={4}
                    className={`${onMenu===4&&styles['selected-menu']} ${styles['menu-item']}`}
                    onClick={handleClickMenu}>
                        <NaviButton to="/playground">Playground</NaviButton>
                        {/* <div className={styles['menu-tip']}>Playground</div> */}
                    </li>
                    <li 
                    key={4}
                    className={`${styles['menu-item']}`}>
                        <span>Fail Case</span>
                        {/* <div className={styles['menu-tip']}>Coming Soon</div> */}
                    </li>
                </ul>
            </div>
            <footer>
                <p>
                    <span>{localStorage.getItem("account")?JSON.parse(localStorage.getItem("account")).email.split('@')[0]:"Who"}</span>
                    <span>{localStorage.getItem("account")?JSON.parse(localStorage.getItem("account")).department:"Are You?"}</span>
                </p>
            </footer>
        </nav>
    )
}